uniform vec3 uColor;
uniform float uIntensity;  // 全体の強さ（フェード用）
uniform float uTime;
uniform float uSeed;       // 天体ごとに揺らぎの位相をずらす

varying vec2 vUv;

void main()
{
    // 中心からの正規化距離（0=中心, 1=プレーン端）
    float dist = length(vUv - 0.5) / 0.5;

    // PlanetHighlights と同じ多層ラジアルフォールオフ
    float innerGlow = pow(max(1.0 - dist, 0.0), 3.0);
    float middleGlow = pow(max(1.0 - dist, 0.0), 1.5);

    // 端に行くほど完全に消す（プレーンの矩形が見えないように）
    float edgeFade = 1.0 - smoothstep(0.7, 1.0, dist);

    // ゆっくりした揺らぎ
    float flicker = 0.92 + 0.08 * sin(uTime * 2.0 + uSeed * 6.2831);

    vec3 color = uColor * (innerGlow + middleGlow * 0.35) * flicker;

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(color * uIntensity, edgeFade * uIntensity);
}
